import DynamicPageGroupSelect from "./selected/DynamicPageGroupSelect";
import {useDispatch, useSelector} from "react-redux";
import {setSelectedPageGroup} from "../../redux/slices/dynamicUiSlice";

const DynamicPageGroupSelector = () => {

  const selectedGroup = useSelector((state) => (state.dynamicUi.pages.selectedGroup));
  const _data = useSelector((state) => (state.dynamicUi.pages));
  const dispatch = useDispatch();

  const setValue = (group) => {
    dispatch(setSelectedPageGroup({group}));
  };


  return (

    <DynamicPageGroupSelect setValue={setValue} monthly={true} value={selectedGroup} disabled={_data[selectedGroup]?.loading ?? false}/>
  );
};


export default DynamicPageGroupSelector;

